import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalBody = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 30px;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
`;

const StyledRadioContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	color: rgba(255, 255, 255, 0.5);
`;

const StyledPriceContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledPrice = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	user-select: none;
	pointer-events: none;

	& > ${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledFieldValue = styled.div<{ $color?: string }>`
	display: flex;
	align-items: center;
	gap: 10px;
	user-select: none;
	pointer-events: none;

	& > ${Text} {
		font-weight: 500;
		font-size: 18px;
		color: ${(p) => p.$color ?? '#ffffff'};
	}

	& > ${Text} > span {
		font-weight: 400;
		font-size: 18px;
		color: rgba(255, 255, 255, 0.5);
	}
`;

export {
	StyledButtonsContainer,
	StyledFieldValue,
	StyledModalBody,
	StyledPrice,
	StyledPriceContainer,
	StyledRadioContainer,
};
